import { render } from "./SearchLabelComponent.vue?vue&type=template&id=6b110a64&scoped=true"
import script from "./SearchLabelComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchLabelComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchLabelComponent.vue?vue&type=style&index=0&id=6b110a64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b110a64"]])

export default __exports__